import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LabelPrintInfo, LabelType, PrintLabelEntry, PrintLabelService } from 'chronos-core-client';

@Injectable({
  providedIn: 'root'
})
export class PrintLabelDsService {
  constructor(private printLabelService: PrintLabelService) {}

  public getLabelPrintInfo(productionOrderId: number, labelType: LabelType): Observable<LabelPrintInfo> {
    return this.printLabelService.getPrintInfo({
      productionOrderId,
      labelType
    });
  }

  public printBobbinLabel(producedMaterialId: number, entry: PrintLabelEntry): Observable<void> {
    return this.printLabelService.printBobbinLabel({
      producedMaterialId,
      body: entry
    });
  }

  public printLabel(productionOrderId: number, request: PrintLabelEntry): Observable<void> {
    return this.printLabelService.printLabel({
      productionOrderId,
      body: request
    });
  }
}
